import { DatePicker, Pagination, Table } from "antd";
import type { PaginationProps } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { getClientDues, resetDues } from "../../redux/actions/duesActions";
import { RootState } from "../../redux/rootReducer";
import tableUtils from "../../utils/tableUtils";
import { ClientDuesColumn } from "../../shared/table/columns";
import SearchComponent from "../_shared/SearchComponent";

const { RangePicker } = DatePicker;

const DuesTab = () => {
  const disptach = useDispatch();
  const { clientId } = useParams();
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [effect, setEffect] = useState(false);
  const { clientDues, clientDuesResponse, clientDuesPending } = useSelector(
    (state: RootState) => state.dues,
  );

  useEffect(() => {
    disptach(resetDues());
  }, []);

  useEffect(() => {
    disptach(
      getClientDues({
        clientId,
        page,
        searchText,
        from: dateRange.from,
        to: dateRange.to,
      }),
    );
  }, [page, effect]);

  // useEffect(() => {
  //   console.log("Client Dues: ", clientDues);
  // }, [clientDues]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const onRangeChange: RangePickerProps["onChange"] = (dates, dateStrings) => {
    if (dates) setDateRange({ from: dateStrings[0], to: dateStrings[1] });
    else setDateRange({ from: "", to: "" });
    setPage(1);
    setEffect(!effect);
  };

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  return (
    <div className="pb-24">
      <div className="mb-4 flex justify-between">
        <div className="space-x-4">
          <SearchComponent handleSearch={handleSearch} />
          <RangePicker onChange={onRangeChange} className="w-[256px]" />
        </div>
        {/* <div className="flex gap-1">
          <Button disabled>Batch Edit</Button>
          <Button
            icon={icons.DotsHorizontal()}
            className="flex items-center justify-center"
            disabled
          />
        </div> */}
      </div>
      <div>
        <Table
          rowKey={(record: any) => {
            return record.id;
          }}
          columns={tableUtils.buildColumns(clientDues, ClientDuesColumn)}
          dataSource={clientDues}
          pagination={false}
          size="middle"
          scroll={{ x: 1024 }}
          loading={{
            spinning: clientDuesPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <div className="text-right mt-4">
        <Pagination
          current={page}
          onChange={handlePageChange}
          total={clientDuesResponse?.count}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default DuesTab;
